import styled from "styled-components";

export const Banner = styled.div`
  position: absolute;
  left: calc(-50vw + 50%);
  height: 3rem;
  width: 100vw;
  bottom: 0;
  padding: 0 0 2rem 0;
  color: #05386b;
  text-align: center;
`